import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import LevelTable from '@/components/LevelTable.vue';
import Loading from '@/components/Loading.vue';
import _ from 'lodash';
import BackButton from '@/components/BackButton.vue';
const archetypeModule = namespace('archetypes');
let CharactersArchetypesDetail = class CharactersArchetypesDetail extends Vue {
    constructor() {
        super(...arguments);
        this.toOrdinalSuffix = (value) => {
            const digits = [value % 10, value % 100];
            const ordinals = ['st', 'nd', 'rd', 'th'];
            const oPattern = [1, 2, 3, 4];
            const tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];
            return oPattern.includes(digits[0]) && !tPattern.includes(digits[1])
                ? value + ordinals[digits[0] - 1]
                : value + ordinals[3];
        };
    }
    created() {
        this.fetchArchetypes();
    }
    get title() {
        return this.archetypeName + Vue.prototype.$titleSuffix;
    }
    get archetype() {
        return this.archetypes.find(({ name }) => name === this.archetypeName);
    }
    get correctedLevels() {
        return this.archetype && _.mapValues(this.archetype.leveledTable, (fields, index) => ({
            Level: this.toOrdinalSuffix(parseInt(index)),
            ..._(fields)
                .keyBy('key')
                .mapValues('value')
                .value()
        }));
    }
};
__decorate([
    archetypeModule.State
], CharactersArchetypesDetail.prototype, "archetypes", void 0);
__decorate([
    archetypeModule.Action
], CharactersArchetypesDetail.prototype, "fetchArchetypes", void 0);
__decorate([
    Prop(String)
], CharactersArchetypesDetail.prototype, "archetypeName", void 0);
__decorate([
    Prop(Boolean)
], CharactersArchetypesDetail.prototype, "isHidingBack", void 0);
CharactersArchetypesDetail = __decorate([
    Component({
        components: {
            VueMarkdown,
            LevelTable,
            BackButton,
            Loading
        }
    })
], CharactersArchetypesDetail);
export default CharactersArchetypesDetail;
